import MySurveys from "./MySurveys";

export default MySurveys;
